<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="model.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="900px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="出厂编号">
            <el-input v-model="model.factoryNo" disabled placeholder="系统自动生成"/>
          </el-form-item>
          <el-form-item label="工单号">
            <el-input v-model="model.repairOrderNo" disabled placeholder="系统自动生成"/>
          </el-form-item>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: left; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table
              v-if="model.attachments"
              ref="payData"
              :data="model.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.fileName"
                    class="tabInput"
                    style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";

  export default {
    name:"KZGReportEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        constant,
        files: [],
        imgUrls: [],
        selection: [],
        index: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        model: {
          pkid: "",
          factoryNo: "",
          repairOrderNo: "",
          attachments:[],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.model.factoryNo = row.cableCode;
        this.model.repairOrderNo = row.repairOrder;
        this.model.customerName = row.location;
        this.dialogVisible = true;
      },
      fileDelete(row, index) {
        this.model.attachments.splice(index, 1);
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo/10)-1);
        }
      },
      selectReplaceBill(row) {
        console.log(row);
        this.model.afterSaleNo = row.billNo;
        this.model.customerBillNo = row.customerBillNo;
        this.model.customerId = row.customerId;
        this.model.customerName = row.customerName;
        this.model.factorNo = row.salesOrderNo;
        this.model.elevatorNo = row.elevatorNo;
        this.model.projectName = row.siteName;
        this.model.siteDesc = row.note;
        this.model.details = row.details;

      },
      getDetails(row, index) {
        console.log(row,index);
        this.model.details[index].materialId = row.id;
        this.model.details[index].materialName = row.name;
        this.model.details[index].materialNo = row.no;
      },
      getDetails1() {
        this.model.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialName: "",
          materialNo: "",
          quantity: 0,
          unit: "",
        });
      },
      oneDelete(index) {
        this.model.details.splice(index, 1);
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.model.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.model.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      getData() {
        this.$http
          .get("basic", `models/${this.model.pkid}`)
          .then(resp => {
            this.model = resp;
            this.model.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      // beforeAvatarUpload(file) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.model.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "checkReportBinds", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
